import script from "./ShopAccounts.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopAccounts.vue?vue&type=script&setup=true&lang=js"

import "./ShopAccounts.vue?vue&type=style&index=0&id=4da272b1&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4da272b1"]])

export default __exports__